document.addEventListener('DOMContentLoaded', () => {
  const messageEls = document.querySelectorAll('[id^="variant-delivery-message-"]');
  if (!messageEls.length) return;

  const renderMessage = (messageEl, variant) => {
    if (!variant) {
      messageEl.innerHTML = '';
      return;
    }

    // Udsolgt
    if (!variant.available) {
      messageEl.innerHTML = '';
      return;
    }

    // På lager
    if (variant.inventory_quantity > 0) {
      messageEl.innerHTML = '<p><strong>Ready to ship</strong> – within 3–5 business days</p>';
      return;
    }

    // Made to order
    messageEl.innerHTML = '<p><strong>Made to order</strong> – production time 10–15 business days</p><p>Each piece is handcrafted and may vary slightly from the image.</p>';
  };

  const getSelectedVariantId = (productId, initialVariantId) => {
    const picker = document.querySelector(`variant-picker[data-product-id="${productId}"]`);

    // Produkter med variant-picker
    if (picker) {
      const checkedRadio = picker.querySelector('input[type="radio"]:checked[data-variant-id]');
      if (checkedRadio?.dataset.variantId) {
        return checkedRadio.dataset.variantId;
      }

      const selectedOption = picker.querySelector('select option:checked[data-variant-id]');
      if (selectedOption?.dataset.variantId) {
        return selectedOption.dataset.variantId;
      }
    }

    // Fallback til initial variant (vigtigt for produkter uden varianter)
    return initialVariantId || null;
  };

  const initMessage = (messageEl) => {
    const productId = messageEl.dataset.productId;
    const initialVariantId = messageEl.dataset.initialVariantId;
    const dataEl = document.getElementById(`VariantDeliveryData-${productId}`);
    if (!dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const update = () => {
      const variantId = getSelectedVariantId(productId, initialVariantId);
      if (!variantId) {
        messageEl.innerHTML = '';
        return;
      }

      const variant = data.variants?.[String(variantId)];
      renderMessage(messageEl, variant);
    };

    // Første load
    update();

    // Opdater ved variantskift
    document.addEventListener('change', (event) => {
      const picker = event.target.closest(`variant-picker[data-product-id="${productId}"]`);
      if (!picker) return;
      setTimeout(update, 0);
    });

    document.addEventListener('click', (event) => {
      const picker = event.target.closest(`variant-picker[data-product-id="${productId}"]`);
      if (!picker) return;
      setTimeout(update, 0);
    });
  };

  messageEls.forEach(initMessage);
});